export const NAVIGATION_PATHS = {
    NEW_SHIFT: "shift/new",
    MEMBER_LOOKUP: "/member-lookup",
    DELETE_SHIFT: "/schedule/shift/delete",
    CREATE_SESSION: "/schedule/shift/session/create",
    SHIFT_BOOKING: "/schedule/shift/booking",
    SWAP_SESSION: "/schedule/shift/session/swap",
    LIVE_SWAP_SESSION: "/live-dashboard/session/swap",
    EDIT_SHIFT: "shift/edit",
    MY_SESSIONS: "/mysessions",
    MY_AVAILABILITY: "/myavailability",
    MY_HISTORY: "/myhistory",
    TAG_MANAGER: "/tag-manager",
};